import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Util from 'lib/util';

import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import CommonFns from 'functions/common.ts';

function PaymentAdvanceList(props) {
  const Config = {
    purchase: {
      apiPath: '/prepayOrder/getPageList',
      countApi: '/prepayOrder/count',
      countTransform: data => {
        let { 0: a, 1: b, 2: c, 3: d, 4: e } = data;
        setCount([undefined, (a || 0) + (d || 0) + (e || 0), b]);
      },
      orderProperty: 'createTime',
      //枚举列表
      arrEnumField: [
        {
          mainKey: 'B02_PrepayOrder_status',
          subKey: 'status',
          value: 'paymentStatusName'
        }
      ],
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/payment/advance/detail',
      searchBarPlaceholder: '供应商名称/编码、预付款单号',
      tabs: ['全部', '待发布', '待审核'],
      tabConfig: [
        [], //全部
        [0, 3, 4], //待发布
        [1] //待审核
      ]
    },
    sale: {
      apiPath: '/cPrepayOrder/getPageList',
      orderProperty: 'createTime',
      //枚举列表
      arrEnumField: [
        {
          mainKey: 'B02_PrepayOrder_status',
          subKey: 'status',
          value: 'paymentStatusName'
        }
      ],
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/cust-payment/advance/detail',
      searchBarPlaceholder: '客户名称/编码、预付款单号',
      tabs: ['全部']
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    decimalPlace,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setListField,
    setTotalField,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  //扩展搜索参数
  self.beforeSearch = async function () {
    if (self.isPurchase) {
      self.searchQueries.orderStatus = !Util.isEmpty(
        config.tabConfig[currentTab]
      )
        ? config.tabConfig[currentTab]
        : undefined;
      self.searchQueries.status = !Util.isEmpty(config.tabConfig[currentTab])
        ? config.tabConfig[currentTab]
        : undefined;
    }
  };

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.ppmXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.ppmXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass('ppm', item.status)
                            }
                          >
                            {item.paymentStatusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        {self.isPurchase && (
                          <li>
                            <label>供应商</label>
                            <div>
                              {item.innerVendorName}({item.innerVendorCode})
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>客户</label>
                            <div>
                              {item.innerCustomerName}({item.innerCustomerCode})
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布时间</label>
                          <div>
                            {formatDate(item.publishTime, 'YYYY-MM-DD')}
                          </div>
                        </li>
                        <li>
                          <label>发布人</label>
                          <div>{item.publishName}</div>
                        </li>
                        <li>
                          <label>预付款金额</label>
                          <div>
                            {formatNumber(item.prepayTotalAmount, item.AMOUNT)}
                          </div>
                        </li>
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

PaymentAdvanceList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(PaymentAdvanceList);
